import React, { useState, useEffect } from 'react';

import '../css/ChatBot.css';
import i18n from '../i18n';
import {
    postUISettingsToIframe,
    getHostThemeForChatbot,
    normalizeChatbotLanguage,
} from '../functions/chatBotUiSettings';

// #7680 - Implement BPost Chatbot
function ChatBot() {

    const [isVisible, setIsVisible] = useState(true);
    const [isExpanded, setIsExpanded] = useState(true);

    const [chatWidth, setChatWidth] = useState(100);
    const [chatHeight, setChatHeight] = useState(100);
    
    
    // If the user closed the widget entirely, render nothing
    //if (!isVisible) return null;

    /*
    * Additional styles that may help:
        position: fixed;
        border-width: 0px;
        z-index: 999999;
        bottom: 20px;
        left: unset;
        right: 20px;
    * */

    useEffect(() => {
        const chatResizeHandler = (event) => {
            console.log('CHATBOT MESSAGE RECEIVED:', event.data);

            // Optional hardening: only trust the chatbot origin
            if (event.origin !== 'https://xbcsa-chat-ac01.bpost.cloud') return;

            if (!event.data || event.data.type !== 'chatWidgetResize') {
                return;
            }

            const width = Number(event.data.width);
            const height = Number(event.data.height);
            console.log('RESIZING CHATBOT TO:', width, 'x', height);

            if (!Number.isFinite(width) || !Number.isFinite(height)) {
                console.error('Invalid chatbot size:', event.data);
                return;
            }

            setChatWidth(width);
            setChatHeight(height);

            const iframe = document.getElementById('bot');
            if (iframe) {
                iframe.style.width = `${width}px`;
                iframe.style.height = `${height}px`;
            }
        };

        console.log('Parent: registering chatbot listener');
        window.addEventListener('message', chatResizeHandler);
        return () => window.removeEventListener('message', chatResizeHandler);
    }, []); // empty deps = register once on mount

    // private chatResizeHandler = (event: MessageEvent): void => {
    //     console.log('CHATBOT MESSAGE RECEIVED:', event.data);
    //     if (!event.data || event.data.type !== 'chatWidgetResize') {
    //         return;
    //     }
    //     const width = Number(event.data.width);
    //     const height = Number(event.data.height);
    //     console.log('RESIZING CHATBOT TO:', width, 'x', height);
    //     if (!Number.isFinite(width) || !Number.isFinite(height)) {
    //         console.error('Invalid chatbot size:', event.data);
    //         return;
    //     }
    //     this.chatWidth = width;
    //     this.chatHeight = height;
    //
    //
    //     const iframe = document.getElementById('bot') as HTMLIFrameElement | null;
    //     if (iframe) {
    //         iframe.style.width = `${width}px`;
    //         iframe.style.height = `${height}px`;
    //     }
    // };
    // ngOnInit(): void {
    //     console.log('Parent: registering chatbot listener');
    //     window.addEventListener(
    //         'message',
    //         this.chatResizeHandler
    //     );
    // }
    // ngOnDestroy(): void {
    //     window.removeEventListener(
    //         'message',
    //         this.chatResizeHandler
    //     );
    // }    
    
    
    return (
        // <iframe
        //     id="bot"
        //     src="https://xbcsa-chat-ds01.bpost.cloud/"
        //     title="Chatbot"
        //     frameBorder="0"
        //     style={{
        //         width: '400px',
        //         height: '400px',
        //         border: 'none',
        //         display: 'block'
        //     }}
        // />


        <div
            className="chat-container"
            style={{
                width: `${chatWidth}px`,
                height: `${chatHeight}px`,
            }}>
            <iframe
                id="bot"
                title="ChatBot"
                src="https://xbcsa-chat-ac01.bpost.cloud/"
                frameBorder="0"
                onLoad={() =>
                    postUISettingsToIframe({
                        theme: getHostThemeForChatbot(),
                        language: normalizeChatbotLanguage(i18n.language),
                    })
                }>
            </iframe>
        </div>
    );
};

export default ChatBot;